import { styled } from 'styled-components'

export const StyledNav = styled.nav(({ theme }) => `
  background: transparent;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.3em;
  position: absolute;
  right: 0;
  top: 0;  // was bottom
  margin: 20px 10px;

  @media (max-width: ${theme.screen.small}) {
    display: none;
  }
`)

export const StyledNavItem = styled.button(({ theme }) => `
  font-size: 20px;
  background: transparent;
  color: ${theme.colors.palette.secondary};
  border-width: 0;

  &:hover {
    opacity: 0.5;
  }
`)

export const StyledNavSeparator = styled.span`
  font-size: 18px;
`

export const StyledThemeToggle = styled.button(({ theme }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.4em;
  padding: 0.35em 0.45em;
  font-size: 24px;
  color: ${theme.colors.palette.secondary};
  background: transparent;
  border: none;
  border-radius: 999px;

  &:hover {
    opacity: 0.7;
  }
`)
